import { render, staticRenderFns } from "./logkayitlari.vue?vue&type=template&id=de32a408"
import script from "./logkayitlari.vue?vue&type=script&lang=js"
export * from "./logkayitlari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports